export const cents = (value: any, originValue: any) => {
  if (typeof originValue === "number") {
    value = originValue / 100;
  }
  return value;
};
